<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-sm-6">
            <h3>{{ $t("appspecificdata") }}</h3>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">{{ $t("management") }}</a></li>
              <li class="breadcrumb-item active">{{ $t("appspecificdata_management") }}</li>
            </ol>
          </div>
          <div class="col-sm-6">
            <!-- Bookmark Start-->
            <div class="bookmark">
              <ul>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Tables"><i data-feather="inbox"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Chat"><i data-feather="message-square"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Icons"><i data-feather="command"></i></a></li>
                <li><a href="javascript:void(0)" data-container="body" data-bs-toggle="popover" data-placement="top"
                    title="" data-original-title="Learning"><i data-feather="layers"></i></a></li>
                <li><a href="javascript:void(0)"><i class="bookmark-search" data-feather="star"></i></a>
                  <form class="form-inline search-form">
                    <div class="form-group form-control-search">
                      <input type="text" :placeholder="$t('search') + '...'">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
            <!-- Bookmark Ends-->
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-9">
          <div class="card">
            <div class="card-header pb-0">
              <h5 v-if="editMode">{{ $t("edit_appspecificdata") }}</h5>
              <h5 v-else>{{ $t("create_appspecificdata") }}</h5>
            </div>
            <LanguagePicker v-model="selectedLanguage" />
            <div class="card-body">
              <div class="form theme-form">
                <div class="row">
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("designation") }}*</label>
                      <input class="form-control" type="text" v-model="appspecificdata.namesMap[selectedLanguage]">
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>Eindeutige Bezeichnung (für Referenzierung zur App)*</label>
                      <input class="form-control" type="text" v-model="appspecificdata.uniqueName">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col py-0">
                    <div class="mb-3">
                      <label>{{ $t("app") }}*</label>
                      <v-select class="mt-0 pt-0" v-model="appspecificdata.app" :items="apps" item-text="name"
                        item-value="id" append-icon="" hide-details>
                        <template slot="item" slot-scope="data">
                          <img style="width:40px;height: 40px;" class="rounded-lg app-icon mr-5"
                            :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                        <template class="py-2" slot='selection' slot-scope="data">
                          <img style="width:40px;height: 40px;" class="rounded-lg app-icon my-1 mr-5"
                            :src="`/files/images/${data.item.icon}`"> {{ data.item.name }}
                        </template>
                      </v-select>
                      <!-- <input class="form-control" type="text" v-model="placement.app"> -->
                    </div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("fetchUrl") }}*
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon size="16" v-on="on">fa fa-info-circle</v-icon>
                          </template>
                          <span>{{ $t('fetchUrl_hint') }}</span>
                        </v-tooltip>
                      </label>
                      <input class="form-control" type="text" v-model="appspecificdata.fetchUrl">
                    </div>
                    <div class="tooltip" :data-tip="$t('fetchUrl_hint')"></div>
                  </div>
                  <div class="col">
                    <div class="mb-3">
                      <label>{{ $t("type") }}*</label>
                      <input class="form-control" type="text" v-model="appspecificdata.type">
                    </div>
                  </div>
                </div>
                <button style="float: right;" @click="save()" class="btn btn-primary" type="button"
                  data-bs-original-title="" title="">{{ $t("save") }}</button>
                <button class="btn btn-secondary mr-2" style="float: right;" @click="$routerBack()">{{
                  $t("cancel")
                }}</button>
              </div>
            </div>
          </div>

        </div>

        <div class="col-3">
          <div class="card">
            <div class="card-header pb-0">
              <h5>{{ $t("actions") }}</h5>
            </div>
            <div class="card-body" v-if="editMode">
              <button @click="showDeleteConfirmation = true" class="btn btn-danger" type="button"
                data-bs-original-title="" title="">{{ $t("delete_appspecificdata") }}</button>
            </div>
            <div class="card-body" v-else>
              <p>{{ $t("APP_SAVE_BEFORE_DELETE_HINT") }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->

      <div class="modal fade show" v-show="showDeleteConfirmation" tabindex="-1" aria-labelledby="exampleModalCenter"
        style="display: block; padding-right: 17px; background: rgba(0,0,0,.5);" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t("delete_appspecificdata") }}</h5>
              <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"
                data-bs-original-title="" title="" @click="(showDeleteConfirmation = false)"></button>
            </div>
            <div class="modal-body">
              <p>{{ $t("confirm_delete_appspecificdata") }}</p>
            </div>
            <div class="modal-footer">
              <button @click="(showDeleteConfirmation = false)" class="btn btn-secondary" type="button"
                data-bs-dismiss="modal" data-bs-original-title="" title="">{{ $t("cancel") }}</button>
              <button @click="deleteSpecificData()" class="btn btn-danger" type="button" data-bs-original-title=""
                title="">{{
  $t("delete")
                }}</button>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { MapPinIcon, PlusSquareIcon } from 'vue-feather-icons'

export default {

  props: {
    appspecificdataId: Number,
  },

  components: {
    apexcharts: VueApexCharts,
    MapPinIcon,
    PlusSquareIcon,
  },
  data() {
    return {
      editMode: false,

      appspecificdata: {
        namesMap: {},
        names: [],
        app: null,
        type: "",
        uniqueName: "",
        fetchUrl: ""
      },

      selectedLanguage: null,

      tooltip: false,

      apps: [],

      tenants: [],
      showDeleteConfirmation: false,

      map: {
        center: {
          latitude: 52.218945,
          longitude: 13.439067
        },
        zoom: 10,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },

      boundaries: [],
    };
  },

  mounted() {
    this.selectedLanguage = this.$locale;
    console.log(this.appspecificdataId);
    this.fetchApps();
    if (this.appspecificdataId != null) {
      this.editMode = true;
      this.fetchEditingSpecificData();
    } else {
    }
  },

  methods: {
    _validate() {

      if (this.appspecificdata.name == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("designation") }));
        return false;
      }
      if (this.appspecificdata.packageName == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("packageName") }));
        return false;
      }
      if (this.appspecificdata.icon == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("icon") }));
        return false;
      }
      if (this.appspecificdata.description == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("description") }));
        return false;
      }
      if (this.appspecificdata.playStoreUrl == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("playStoreUrl") }));
        return false;
      }
      if (this.appspecificdata.appStoreUrl == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("appStoreUrl") }));
        return false;
      }
      if (this.appspecificdata.baseUrl == "") {
        this.$noty.error(this.$t("empty_value", { name: this.$t("baseurl") }));
        return false;
      }
      console.log(this.appspecificdata);
      return true;
    },
    fetchApps(resetPage = false) {
      if (resetPage) this.page = 1;
      var _this = this;
      this.$axios
        .get("/api/app")
        .then(function (response) {
          _this.apps = response.data.content;
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchEditingSpecificData() {
      var _this = this;
      this.$axios
        .get("/api/appspecificdata/" + this.appspecificdataId)
        .then(function (response) {
          _this.appspecificdata = response.data;
        })
        .catch(this.onError);
    },
    // fetchApps(search = ""){
    //   if(search == null) return;
    //   var _this = this;
    //   progressIndicator.hidden = false;
    //   this.$axios
    //     .get("/api/app?size=50&search=" + search)
    //     .then(function (response) {
    //       if(_this.tenants.length == 0) _this.tenants = response.data.content;
    //       for (let i = 0; i < response.data.content.length; i++) {
    //         const tenant = response.data.content[i];
    //         if(_this.tenants.filter(t => { return t.name == tenant.name }).length == 0){
    //           _this.tenants.push(tenant);
    //         }
    //       }

    //       if(_this.tenantId != null){
    //         // Remove Tenant which is being edited (no self-adding)
    //         for (let i = _this.tenants.length - 1; i >= 0; i--) {
    //           const tenant = _this.tenants[i];
    //           if(tenant.id == _this.tenantId){
    //             _this.tenants.splice(i, 1);
    //           }
    //         }
    //       }
    //       _this.$forceUpdate();
    //     })
    //     .catch(this.onError)
    //     .finally(this.finalize);
    // },
    save() {
      if (!this._validate()) return;
      var appspecificdata = Object.assign({}, this.appspecificdata);
      appspecificdata.appId = appspecificdata.app.id == undefined ? appspecificdata.app : appspecificdata.app.id;
      appspecificdata.names = this.appspecificdata.namesMap;
      delete appspecificdata.namesMap;
      delete appspecificdata.app;
      if (this.editMode) {
        this.updateSpecificData(appspecificdata);
      } else {
        this.createSpecificData(appspecificdata);
      }
    },
    createSpecificData(appspecificdata) {
      var _this = this;
      this.$axios
        .post("/api/appspecificdata", appspecificdata)
        .then(function (response) {
          _this.$noty.success(_this.$t("appspecificdata_created"));
          _this.$router.push("/appspecifics");
        })
        .catch(this.onError);
    },
    updateSpecificData(appspecificdata) {
      var _this = this;
      this.$axios
        .put("/api/appspecificdata/" + this.appspecificdataId, appspecificdata)
        .then(function (response) {
          _this.$noty.success(_this.$t("appspecificdata_edited"));
          _this.$router.push("/appspecifics");
        })
        .catch(this.onError);
    },
    deleteSpecificData() {
      var _this = this;
      this.$axios
        .delete("/api/appspecificdata/" + this.appspecificdataId)
        .then(function (response) {
          _this.showDeleteConfirmation = false;
          _this.$noty.success(_this.$t("appspecificdata_deleted"));
          _this.$router.push("/appspecifics");
        })
        .catch(this.onError);
    },
    logError(error) {
      console.log(error);
    },
    onError(error) {
      console.log(error);
    },
    finalize() {
      progressIndicator.hidden = true;
    }
  },
};
</script>

<style>

</style>